import React, { useState, useEffect } from 'react';
import PropTypes from 'prop-types';
import classnames from 'classnames';
import debounce from 'lodash.debounce';
import FiltersList from './FiltersList';
import { isDeviceDesktop, getResponsiveFilterClassnames, buildUrlQuery } from '../helpers';
import CloseMobileForm from './CloseMobileForm';
import ResetDesktopForm from './ResetDesktopForm';
import MobileFormToolbar from './MobileFormToolbar';
import { SEARCH, REFINE, MORE_FILTERS_CLASSES } from '../constants';
const SearchFilter = ({
  searchFilterRef,
  listComponentName,
  data,
  filters,
  hasUrl,
  entity,
  handleSearch,
  name,
  isCollapsedOnResponsive,
  displaySearchFilter,
  setDisplaySearchFilter,
  groupAfterDesktop,
  groupAfterMobile,
  filterValues,
  setAppliedFilters,
  query
}) => {
  const [moreFiltersMobileCollapsed, setMoreFiltersMobileCollapsed] = useState(true);
  const [moreFiltersDesktopCollapsed, setMoreFiltersDesktopCollapsed] = useState(true);
  const doSubmit = newValues => {
    const newQuery = filterValues ? buildUrlQuery(newValues, filters, listComponentName, query) : '';
    handleSearch(newQuery);
    setMoreFiltersDesktopCollapsed(true);
    setMoreFiltersMobileCollapsed(true);
  };
  const handleSubmit = debounce(newValues => {
    doSubmit(newValues);
  }, 200);
  useEffect(() => {
    if (filterValues.shouldSearch) {
      handleSubmit(filterValues);
      setAppliedFilters({
        type: 'resetSearch'
      });
    }
  }, [filterValues, handleSubmit, setAppliedFilters]);
  const formClass = classnames('filter__form filter__form--initial', {
    'filter__form--mobile': isCollapsedOnResponsive && displaySearchFilter,
    'filter__form--collapsible': isCollapsedOnResponsive
  });
  const {
    moreFiltersMobileWrapperClass,
    moreFiltersMobileTogglerClass,
    moreFiltersDesktopWrapperClass,
    moreFiltersDesktopTogglerClass
  } = getResponsiveFilterClassnames(moreFiltersDesktopCollapsed, moreFiltersMobileCollapsed);
  const formId = `filter-${name}-form`;
  const handleReset = () => {
    setAppliedFilters({
      type: 'reset'
    });
    doSubmit();
  };
  const updateFilterValues = (newValues, shouldSubmit) => {
    setAppliedFilters({
      newValues,
      shouldSearch: shouldSubmit,
      type: 'update'
    });
  };
  const shouldGroup = !!(groupAfterDesktop || groupAfterMobile);
  return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("form", {
    ref: searchFilterRef,
    className: formClass,
    "data-testid": formId,
    id: formId,
    onSubmit: e => {
      e.preventDefault();
      doSubmit(filterValues);
    }
  }, displaySearchFilter && /*#__PURE__*/React.createElement(CloseMobileForm, {
    handleClose: () => setDisplaySearchFilter(false)
  }), /*#__PURE__*/React.createElement("div", {
    className: "filter filter--search-refine"
  }, /*#__PURE__*/React.createElement(ResetDesktopForm, {
    handleReset: handleReset
  }), /*#__PURE__*/React.createElement("div", {
    className: "filter__wrapper filter__wrapper--search-refine"
  }, !shouldGroup && /*#__PURE__*/React.createElement(FiltersList, {
    shouldSearch: !hasUrl,
    data: data,
    filters: filters,
    hasUrl: hasUrl,
    entity: entity,
    filterValues: filterValues,
    updateFilterValues: updateFilterValues
  }), shouldGroup && /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(FiltersList, {
    shouldSearch: !hasUrl,
    data: data,
    filters: filters.slice(0, groupAfterMobile),
    hasUrl: hasUrl,
    entity: entity,
    filterValues: filterValues,
    updateFilterValues: updateFilterValues
  }), !!groupAfterMobile && /*#__PURE__*/React.createElement("button", {
    "data-testId": "search-filter-mobile-toggler",
    className: moreFiltersMobileTogglerClass,
    type: "button",
    onClick: () => setMoreFiltersMobileCollapsed(!moreFiltersMobileCollapsed)
  }, "Filters"), /*#__PURE__*/React.createElement("div", {
    className: moreFiltersMobileWrapperClass
  }, /*#__PURE__*/React.createElement("div", {
    className: MORE_FILTERS_CLASSES.MOBILE_CONTENT
  }, /*#__PURE__*/React.createElement(FiltersList, {
    shouldSearch: !hasUrl && isDeviceDesktop(),
    data: data,
    filters: filters.slice(groupAfterMobile, groupAfterDesktop ? groupAfterDesktop - 1 : 0),
    hasUrl: hasUrl,
    entity: entity,
    filterValues: filterValues,
    updateFilterValues: updateFilterValues
  }), !!groupAfterDesktop && /*#__PURE__*/React.createElement("button", {
    "data-testId": "search-filter-desktop-toggler",
    className: moreFiltersDesktopTogglerClass,
    type: "button",
    onClick: () => setMoreFiltersDesktopCollapsed(!moreFiltersDesktopCollapsed)
  }, moreFiltersDesktopCollapsed ? 'More filters' : 'Less filters'), /*#__PURE__*/React.createElement("div", {
    className: moreFiltersDesktopWrapperClass
  }, /*#__PURE__*/React.createElement("div", {
    className: MORE_FILTERS_CLASSES.DESKTOP_CONTENT
  }, /*#__PURE__*/React.createElement(FiltersList, {
    shouldSearch: false,
    data: data,
    filters: filters.slice(groupAfterDesktop),
    hasUrl: hasUrl,
    entity: entity,
    filterValues: filterValues,
    updateFilterValues: updateFilterValues
  })), /*#__PURE__*/React.createElement("div", {
    className: MORE_FILTERS_CLASSES.DESKTOP_BUTTONS
  }, /*#__PURE__*/React.createElement(ResetDesktopForm, {
    handleReset: handleReset
  }), /*#__PURE__*/React.createElement("button", {
    className: "button button--full-width",
    type: "submit"
  }, SEARCH)))), /*#__PURE__*/React.createElement("div", {
    className: MORE_FILTERS_CLASSES.MOBILE_BUTTONS
  }, /*#__PURE__*/React.createElement(ResetDesktopForm, {
    handleReset: handleReset
  }), /*#__PURE__*/React.createElement("button", {
    className: "button button--full-width",
    type: "submit"
  }, SEARCH)))), !displaySearchFilter && /*#__PURE__*/React.createElement("button", {
    className: "button button--full-width",
    type: "submit"
  }, SEARCH))), displaySearchFilter && /*#__PURE__*/React.createElement(MobileFormToolbar, {
    formId: formId,
    handleReset: handleReset
  })), isCollapsedOnResponsive && !displaySearchFilter && /*#__PURE__*/React.createElement("div", {
    className: "filter__refine filter__refine--mobile-close",
    "data-testid": "refine-mobile"
  }, /*#__PURE__*/React.createElement("div", {
    role: "button",
    onClick: () => setDisplaySearchFilter(true),
    "aria-label": "Toggle Search Filter"
  }, REFINE)));
};
SearchFilter.propTypes = {
  data: PropTypes.object.isRequired,
  filters: PropTypes.array.isRequired,
  searchFilterRef: PropTypes.object.isRequired,
  hasUrl: PropTypes.bool.isRequired,
  entity: PropTypes.string.isRequired,
  handleSearch: PropTypes.func.isRequired,
  name: PropTypes.string.isRequired,
  displaySearchFilter: PropTypes.bool.isRequired,
  setDisplaySearchFilter: PropTypes.func.isRequired,
  isCollapsedOnResponsive: PropTypes.bool.isRequired,
  groupAfterDesktop: PropTypes.number.isRequired,
  groupAfterMobile: PropTypes.number.isRequired,
  filterValues: PropTypes.object.isRequired,
  setAppliedFilters: PropTypes.func.isRequired,
  listComponentName: PropTypes.string,
  query: PropTypes.object
};
SearchFilter.defaultProps = {
  listComponentName: '',
  query: {}
};
export default SearchFilter;
//# sourceMappingURL=SearchFilter.js.map